import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WaypointService } from 'src/app/services/core/waypoint.service';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';
import { LanguageService } from 'src/app/services/account/language.service';
import { AnalyticsLoggerService } from 'src/app/services/logging/analytics-logger.service';
import { NavigationService } from 'src/app/services/core/navigation.service';
import { NavigationReplayService } from 'src/app/services/map/navigation-replay.service';
import { LocationService } from 'src/app/services/platform/location.service';
import { LatLng } from 'src/app/models/latlng';
import { CommonModule } from '@angular/common';
import { VehiclePropertyComponent } from '../../ui-panels/vehicle-panel/vehicle-property/vehicle-property.component';

@Component({
  standalone: true,
  selector: 'app-navigation-set-dialog',
  templateUrl: './navigation-set-battery-dialog.component.html',
  imports: [CommonModule, VehiclePropertyComponent],
  styleUrl: './navigation-set-battery-dialog.component.scss'
})
export class NavigationSetBatteryDialogComponent {
  public batteryLevel: number = 73;
  // original brand/model name (e.g. "Tesla Model 3"), not the user's custom nickname
  public vehicleName: string = '';

  constructor(
    public dialogRef: MatDialogRef<NavigationSetBatteryDialogComponent>,
    public languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private waypointService: WaypointService, private loggerService: AnalyticsLoggerService,
    private navigationService: NavigationService, private vehicleService: VehicleService,
    private navigationReplayService: NavigationReplayService, private locationService: LocationService
  ) {
    this.batteryLevel = data.chargedBatteryLevel;
    this.vehicleName = this.vehicleService.getSelectedCar()?.Name ?? '';
  }

  public setBatteryClick() {
    // In simulation/replay mode the route start is never advanced to the
    // current (fake) GPS position the way it is during real navigation, so the
    // post-charge replan would otherwise plan from the original origin and
    // restart the simulation from the beginning. Anchor the start at the
    // current charging-station position so the replanned route (and the replay)
    // runs from here to the goal.
    if (this.navigationReplayService.replayMode) {
      const lastPosition = this.locationService.getLastPosition();
      if (lastPosition) {
        this.waypointService.setStartCoordsParams(new LatLng(lastPosition.Latitude, lastPosition.Longitude));
      }
    }
    this.waypointService.deleteChargingWaypoint(this.data.chargingStationId);
    this.navigationService.setSlidersValueChangedIn15seconds(true);
    this.vehicleService.setBattery(this.batteryLevel);
    this.loggerService.onBatteryChangeEvent(this.batteryLevel);
    this.vehicleService.ObservableBatteryChanged.next(this.batteryLevel);
    setTimeout(() => {
      this.navigationService.setSlidersValueChangedIn15seconds(false);
    }, 15000);
    this.dialogRef.close();
  }
}
